import React from 'react';
import { Button } from './Button';
import { ArrowRight, ShieldCheck, Award, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

export const About: React.FC = () => {
  return (
    <section id="about" className="py-24 bg-secondary relative overflow-hidden">
      {/* Background patterns */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {/* Text Content */}
          <div className="order-2 lg:order-1 space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 text-white border border-white/10 text-xs font-bold uppercase tracking-wider backdrop-blur-sm">
                <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
                Who We Are
            </div>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Pioneering the Future of <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400">Men's Health</span>
            </h2>
            
            <div className="space-y-6 text-lg text-gray-400 leading-relaxed">
                <p>
                  We are more than just a clinic; we are a movement dedicated to breaking the stigma around men's health. By combining cutting-edge medical technology with a patient-centric approach, we provide a safe space for men to address their health concerns.
                </p>
                <p>
                  From discreet consultations to comprehensive treatment plans, our ecosystem is built on privacy, expertise, and accessibility.
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-6 border-t border-white/10">
                {[
                    { icon: ShieldCheck, label: "Private & Secure", sub: "100% Confidential" },
                    { icon: Award, label: "Affordable Care", sub: "Health for less" },
                    { icon: Users, label: "Community", sub: "25k+ patients" }
                ].map((item, i) => (
                    <div key={i} className="flex flex-col gap-3 group">
                        <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                            <item.icon size={20} />
                        </div>
                        <div>
                            <h4 className="text-white font-bold text-sm">{item.label}</h4>
                            <p className="text-gray-500 text-xs">{item.sub}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="pt-6">
                <Link to="/about">
                  <Button variant="primary" className="gap-2">
                      Discover Our Mission 
                      <ArrowRight size={18} />
                  </Button>
                </Link>
            </div>
          </div>

          {/* Visual Content */}
          <div className="order-1 lg:order-2 relative">
             <div className="relative rounded-[2.5rem] overflow-hidden border border-white/10 shadow-2xl">
                <div className="absolute inset-0 bg-gradient-to-t from-secondary/80 to-transparent z-10"></div>
                <img 
                    src="https://09da45aa8861e9e09f066d7bf0bbd9f0.cdn.bubble.io/f1765316204944x715265549529753100/40663.jpg?_gl=1*1rin2l3*_gcl_au*OTYxMjAzODg4LjE3NjUzMTUwMDg.*_ga*Njg0NDczNjkxLjE3NjUzMTUwMDg.*_ga_BFPVR2DEE2*czE3NjUzMTUwMDgkbzEkZzEkdDE3NjUzMTYxNzUkajYwJGwwJGgw" 
                    alt="Advanced Medical Facility" 
                    className="w-full h-[500px] object-cover hover:scale-105 transition-transform duration-700"
                />
                
                {/* Floating Badge */}
                <div className="absolute bottom-8 left-8 right-8 z-20 bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-2xl">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-blue-300 text-xs font-bold uppercase tracking-wider mb-1">Success Rate</p>
                            <p className="text-3xl font-bold text-white">98.5%</p>
                        </div>
                        <div className="h-10 w-[1px] bg-white/20"></div>
                        <div>
                             <p className="text-blue-300 text-xs font-bold uppercase tracking-wider mb-1">Patient Satisfaction</p>
                            <p className="text-3xl font-bold text-white">4.9/5</p>
                        </div>
                    </div>
                </div>
             </div>
             
             {/* Decorative Elements */}
             <div className="absolute -z-10 -top-10 -right-10 w-40 h-40 bg-primary/20 rounded-full blur-3xl"></div>
             <div className="absolute -z-10 -bottom-10 -left-10 w-40 h-40 bg-blue-500/20 rounded-full blur-3xl"></div>
          </div>

        </div>
      </div>
    </section>
  );
};